import PropTypes from 'prop-types';
import React from 'react';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const Close = ({ className }) => {
    return (
        <svg
            className={className}
            fill='none'
            style={{ width: '30px', height: '30px' }}
            viewBox='0 0 40 40'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M10.3438 8.89502L31.1115 29.6627L29.669 31.1052L8.90125 10.3375L10.3438 8.89502Z'
                fill='currentColor' />
            <path
                d='M8.89844 29.6626L29.6662 8.89487L31.1087 10.3374L10.3409 31.1051L8.89844 29.6626Z'
                fill='currentColor' />
        </svg>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

const propTypes = {
    className: PropTypes.string
};

Close.propTypes = propTypes;

export default Close;
